import React, { useEffect } from 'react'
import {
  Notification,
  useNotify,
  useRedirect,
  TextInput,
  required, useLogin
} from 'react-admin'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Footer from '../../elements/Footer'
import { theme } from '../../theme'
import { debounce } from 'lodash'
import { Form } from 'react-final-form'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    paddingBottom: 60,
    textAlign: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(1, 0, 1)
  },
  backToLogin: {
    margin: theme.spacing(1, 0, 2)
  }
}))

const VerifyToken = () => {
  const classes = useStyles()
  const redirect = useRedirect()
  const login = useLogin()
  const notify = useNotify()
  const location = useLocation()

  const submit = (values) => {
    login({
      username: location.state?.username,
      password: location.state?.password,
      otp: values.otp
    })
      .catch(() => notify('messages.verifyToken.invalidOrExpiredVerifyCode'))
  }

  const backToLogin = (e) => {
    e.preventDefault()
    redirect('/login')
  }

  useEffect(() => {
    if (!location.state?.username || !location.state?.password) {
      redirect('/login')
    }
  }, [location.state])

  return (
    <MuiThemeProvider theme={theme}>
      <Container component='main' maxWidth='xs'>
        <CssBaseline />
        <div className={classes.paper}>
          <div>
            <Typography component='h1' variant='h5'>
              Two-factor authentication
            </Typography>
            <Form
              className={classes.form}
              onSubmit={submit}
            >
              {props => (
                <from
                  onSubmit={(e) => e.preventDefault()}
                >
                  <TextInput
                    variant='outlined'
                    margin='normal'
                    validate={required('messages.verifyToken.otp.required')}
                    fullWidth
                    id='otp'
                    label='Enter 6 digit code'
                    name='otp'
                    type='otp'
                    autoFocus
                  />
                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='primary'
                    className={classes.submit}
                    onClick={debounce(props.handleSubmit, 300)}
                    disabled={props.submitting || props.invalid}
                  >
                    Verify
                  </Button>
                  <Button
                    fullWidth
                    variant='outlined'
                    color='primary'
                    className={classes.backToLogin}
                    onClick={backToLogin}
                  >
                    Back to Login
                  </Button>
                </from>
              )}
            </Form>
            <Notification />
          </div>
        </div>
      </Container>
      <Footer />
    </MuiThemeProvider>
  )
}

export default VerifyToken
